import { RouteConfig } from 'vue-router';

const Folder = () => import('./views/folder/folder.vue');
const Read = () => import('./views/read/read.vue');

const routers: RouteConfig[] = [
    {
        path: 'folder',
        component: Folder,
    },
    {
        path: 'read',
        component: Read,
    },
    {
        path: '',
        redirect: 'folder'
    },

]
export default routers;
